import { IconHistory } from '@tabler/icons';
import {MoveDown, MoveUp,  SyncAlt, Paid, CompareArrows, Smartphone, ReceiptLong, Bolt, Water} from '@mui/icons-material'
const icons = {
  MoveDown, MoveUp, IconHistory, SyncAlt, Paid, CompareArrows, Smartphone, ReceiptLong, Bolt, Water
};


const Transfer = {
  id: 'transfer',
  title: 'Transfer',
  caption: '',
  type: 'group',
  children: [
    {
      id: 'transfer',
      title: 'Transfer',
      type: 'item',
      icon: icons.CompareArrows,
      url: '/contract/transfer',
      breadcrumbs: false
    },
    {
      id: 'transfer247',
      title: 'Transfer 24/7',
      type: 'item',
      url: '/contract/transfer247',
      icon: icons.Paid,
      breadcrumbs: false
    },
    {
      id: 'intrabank_transfer',
      title: 'IntraBank Transfer',
      type: 'item',
      url: '/contract/intrabank',
      icon: icons.SyncAlt,
      breadcrumbs: false
    },
    {
      id: 'mobile-topup',
      title: 'Mobile Topup',
      type: 'item',
      url: '/topup/mobile',
      icon: icons.Smartphone,
      breadcrumbs: false
    },
    {
      id: 'bill',
      title: 'Bill',
      type: 'collapse',
      icon: icons.ReceiptLong,
      children: [
        {
            id: 'electric',
            title: 'Electric',
            type: 'item',
            url: '/bill/electric',
            icon: icons.Bolt,
            breadcrumbs: false
        },
        {
            id: 'water',
            title: 'Water',
            type: 'item',
            url: '/bill/water',
            icon: icons.Water,
            breadcrumbs: false
        }
      ]
    },
    {
      id: 'history',
      title: 'Transaction History',
      type: 'item',
      url: '/transaction/history',
      icon: icons.IconHistory,
      breadcrumbs: false
    },
  ]
};

export default Transfer;